<template>
  <!-- Add Menu Items as Options Section -->
  <div class="menu-items-as-options-panel">
    <label class="panel-section-label">Add Menu Items as Options</label>

    <div class="menu-items-section">
      <!-- Category Selection -->
      <div class="category-selection">
        <h6 class="font-weight-bold mb-3">Select Category</h6>

        <v-select
          class="v-select-filter"
          v-model="selectedCategory"
          :options="categories"
          placeholder="Choose a category..."
          @input="loadMenuItems"
        />
      </div>

      <!-- Menu Items Selection -->
      <div v-if="selectedCategory" class="menu-items-selection">
        <h6 class="font-weight-bold mb-3">
          <CIcon name="cil-list" class="align-bottom text-success" />
          Select Menu Items
        </h6>

        <div v-if="menuItems.length > 0" class="menu-items-list">
          <div
            v-for="item in menuItems"
            :key="item.id"
            class="menu-item-card p-2 mb-2 rounded border"
            :class="{ selected: selectedMenuItems.some((i) => i.id === item.id) }"
            @click="toggleMenuItemSelection(item)"
          >
            <div class="d-flex align-items-center">
              <input
                type="checkbox"
                :checked="selectedMenuItems.some((i) => i.id === item.id)"
                class="mr-2 cursor-pointer"
                @click.stop="toggleMenuItemSelection(item)"
              />
              <div class="flex-grow-1">
                <div class="font-weight-bold">{{ item.menu_name }}</div>
                <small class="text-muted">{{ item.description }}</small>
              </div>
              <div class="text-right">
                <div class="font-weight-bold">€{{ item.price }}</div>
                <small v-if="item.toPrice" class="text-muted">Takeout Price: €{{ item.toPrice }}</small>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-muted text-center p-3 border rounded">No menu items found in this category</div>
      </div>

      <!-- Selected Items Summary -->
      <div v-if="selectedMenuItems.length > 0" class="selected-items-summary mt-4">
        <h6 class="font-weight-bold">
          <CIcon name="cil-check-circle" class="align-bottom text-success" />
          Selected Items ({{ selectedMenuItems.length }})
        </h6>
        <div class="selected-items-list mt-2">
          <CBadge
            v-for="item in selectedMenuItems"
            :key="item.id"
            color="info"
            class="mr-2 mb-2 selected-item-badge"
            @click="toggleMenuItemSelection(item)"
          >
            {{ item.menu_name }}
            <CIcon name="cil-x" class="ml-1" />
          </CBadge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddMenuItemsAsOptions',
  components: {},
  props: {
    restaurantId: { type: Number | String, required: true },
    selectedItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      submitting: false,

      // Menu Items Section
      selectedCategory: null,
      categories: [],
      menuItems: [],
      selectedMenuItems: [],
    };
  },
  computed: {},
  watch: {
    selectedItems: {
      handler(newValue) {
        if (newValue.length === 0) {
          this.selectedCategory = null;
          this.menuItems = [];
          this.selectedMenuItems = [];
        }
      },
      immediate: true
    },
    selectedMenuItems: {
      handler(newValue) {
        if (newValue.length > 0) {
          this.$emit(
            'update:selected-items',
            newValue.map((item) => ({
              // id: item.id,
              name: item.menu_name,
              description: item.description,
              price: item.price,
              toPrice: item.toPrice,
              type_id: item.type_id,
              sold_out: item.sold_out,
            }))
          );
        }
      },
      deep: true,
    },
  },

  async created() {
    await this.loadCategories();
  },

  methods: {
    async loadCategories() {
      this.loading = true;
      try {
        const response = await this.$axios.get(
          this.$backend.RESTAURANT_LINKED_CATEGORIES.GET_ALL_BY_RESTAURANT_ID_WITH_MENUS.replace(
            '{restaurant_id}',
            this.$route.params.restaurant_id
          ),
          {
            params: {
              menu_fields: 'type_id,description,price,toPrice,sold_out',
            },
          }
        );
        this.categories = response.data;
      } catch (error) {
        this.$toast.error('Failed to load categories');
      } finally {
        this.loading = false;
      }
    },

    async loadMenuItems() {
      this.menuItems = this.selectedCategory.menus;
    },

    toggleMenuItemSelection(item) {
      const index = this.selectedMenuItems.findIndex((i) => i.id === item.id);
      if (index === -1) {
        this.selectedMenuItems.push(item);
      } else {
        this.selectedMenuItems.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.menu-items-as-options-panel {
  border-left: 3px solid #20a8d8;
  padding: 15px;
  background-color: #f8f9fa;
}

.panel-section-label {
  font-weight: bold;
  font-size: 1.1rem;
  color: #20a8d8;
  margin-bottom: 15px;
  display: block;
}

.selected-items-preview {
  margin-bottom: 1rem;
}

.selected-items-list {
  display: flex;
  flex-wrap: wrap;
}

.menu-items-section {
  margin-top: 20px;
}

.menu-items-selection {
  margin: 20px 0 0;
}

.menu-item-card {
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0.5rem;
  border-radius: 4px;
}

.menu-item-card:hover {
  background-color: #f8f9fa;
}

.selected {
  background-color: #e8f4f8;
}

.selected-items-summary {
  margin-top: 20px;
}

.selected-item-badge {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s ease;
}

.selected-item-badge:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.cursor-pointer {
  cursor: pointer;
}
</style>
